import {
  password_validator_styles_default
} from "./chunk.OKGYM2GM.js";
import {
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/password-validator/password-validator.ts
var FadvPasswordValidator = class extends s {
  get rules() {
    return [...this.children].map((c) => c);
  }
  renderBadges() {
    let variant = "danger";
    if (this.validRules > 0) {
      const ratio = this.validRules / this.rules.length;
      if (ratio >= 0.4 && ratio <= 0.8) {
        variant = "warning";
      } else if (ratio > 0.8) {
        variant = "success";
      }
    }
    return [
      ...Array.from({ length: this.validRules }).map(() => {
        return $`<fadv-badge class="password-validator-badge" variant=${variant}></fadv-badge>`;
      }),
      ...Array.from({ length: this.invalidRules }).map(() => {
        return $`<fadv-badge class="password-validator-badge password-validator-badge-error" variant=""></fadv-badge>`;
      })
    ];
  }
  updateBadges() {
    this.validRules = 0;
    this.invalidRules = 0;
    this.rules.forEach((rule) => {
      if (rule.valid) {
        this.validRules++;
      } else {
        this.invalidRules++;
      }
    });
  }
  render() {
    return $`<div tabindex="0" role="list" class="password-validator-rule" @password-rule-change=${this.updateBadges}><div aria-hidden="true" class="password-validator-badges">${this.renderBadges()}</div><slot @slotchange=${this.updateBadges}></slot></div>`;
  }
};
FadvPasswordValidator.styles = password_validator_styles_default;
__decorateClass([
  t()
], FadvPasswordValidator.prototype, "validRules", 2);
__decorateClass([
  t()
], FadvPasswordValidator.prototype, "invalidRules", 2);
FadvPasswordValidator = __decorateClass([
  n("fadv-password-validator")
], FadvPasswordValidator);

export {
  FadvPasswordValidator
};
